import PropTypes from 'prop-types';
import React from 'react';

const AddPhotoIcon = ({ color }) => {
  return (
    <svg
      width="18px"
      height="18px"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 999.98"
      role="img"
    >
      <title>Add profile photo</title>
      <g id="Ellipse_5" data-name="Ellipse 5">
        <circle
          className="cls-1"
          fill="white"
          cx="500"
          cy="499.99"
          r="499.99"
        />
        <path
          className="cls-2"
          d="M500,1000C224.3,1000,0,775.71,0,500S224.3,0,500,0s500,224.3,500,500S775.67,1000,500,1000Zm0-972.2C239.6,27.79,27.78,239.62,27.78,500S239.6,972.21,500,972.21,972.22,760.36,972.22,500,760.37,27.79,500,27.79Z"
          transform="translate(0 -0.01)"
        />
      </g>
      <g id="_" data-name=" " className="cls-3">
        <g className="cls-3">
          <path
            className="cls-4"
            fill={color}
            d="M532.21,481.18H686.42v66.46H532.21V722.33H461.58V547.64H307.39V481.18H461.58V319.78h70.63Z"
            transform="translate(0 -0.01)"
          />
        </g>
      </g>
    </svg>
  );
};

export default AddPhotoIcon;

AddPhotoIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
